export default class HeroBubble {
    constructor(element) {
        this.container = element;
        this.bubble = element.querySelector('[data-hero-bubble-circle]');
        if (!this.bubble) return;

        // Current and target positions (center of container)
        this.currentX = 0;
        this.currentY = 0;
        this.targetX = 0;
        this.targetY = 0;

        // Bleed: how many px the bubble edge may extend past the image
        this.bleed = 20;

        // Lerp factor — lower = smoother / more delay
        this.ease = 0.06;

        this.animating = false;
        this.bindEvents();
    }

    /**
     * Clamp target so only ~bleed px of the visible glow peeks
     * outside the container on every side.
     *
     * Bubble = 500px diameter + 80px blur.
     * The gradient fades so effective visible radius is ~250px.
     */
    clamp(raw, containerSize) {
        const visibleRadius = 250; // 250 (half of 500) + visible blur fringe
        const half = containerSize / 2;
        const limit = Math.max(0, half - visibleRadius + this.bleed);
        return Math.max(-limit, Math.min(limit, raw));
    }

    bindEvents() {
        this.container.addEventListener('mousemove', (e) => {
            const rect = this.container.getBoundingClientRect();

            const rawX = e.clientX - rect.left - rect.width / 2;
            const rawY = e.clientY - rect.top - rect.height / 2;

            this.targetX = this.clamp(rawX, rect.width);
            this.targetY = this.clamp(rawY, rect.height);

            if (!this.animating) {
                this.animating = true;
                this.animate();
            }
        });

        // Stay at last position on mouse leave — no reset
    }

    animate() {
        // Lerp toward target
        this.currentX += (this.targetX - this.currentX) * this.ease;
        this.currentY += (this.targetY - this.currentY) * this.ease;

        this.bubble.style.transform =
            `translate(-50%, -50%) translate(${this.currentX}px, ${this.currentY}px)`;

        // Keep animating until very close to target
        const dx = Math.abs(this.targetX - this.currentX);
        const dy = Math.abs(this.targetY - this.currentY);

        if (dx > 0.1 || dy > 0.1) {
            requestAnimationFrame(() => this.animate());
        } else {
            this.animating = false;
        }
    }
}
